import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
import { calEventFieldValueInputSchema } from './cal-event-field-value-input.js';
import { SET_CAL_EVENT_FIELD_VALUES_MAX } from './set-cal-event-field-values-max.js';
export const setCalEventFieldValuesInputSchema = z.object({
    eventId: requiredUuidString('Event is required.', 'Invalid event ID.'),
    values: z
        .array(calEventFieldValueInputSchema)
        .min(1, 'Enter at least one value.')
        .max(SET_CAL_EVENT_FIELD_VALUES_MAX, `Save at most ${SET_CAL_EVENT_FIELD_VALUES_MAX} fields at once.`)
        .refine((values) => new Set(values.map((value) => value.fieldKey)).size === values.length, 'Each field can be set once per save.'),
});
//# sourceMappingURL=set-cal-event-field-values-input.js.map